<template>
	<div class="networkStatus">
		<div :class="[status.bool ? 'networkStatus__icon--online' : 'networkStatus__icon--offline', 'networkStatus__icon']"></div>
		<div class="networkStatus__label">{{status.val}}</div>
	</div>
</template>

<style lang="scss">
.networkStatus {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  &__icon {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    margin-right: $content;
    display: block;
    &--online {
      background: $ok;
    }
    &--offline {
      background: $error;
    }
  }
}
</style>

<script>
import { EventBus } from './../event-bus'
export default {
	name: 'networkStatus',

	created(){
		this.bindEventHandlers()
		if(window.navigator.onLine){
			this.setStatus('online')
		}else{
			this.setStatus('offline')
		}
	},
	methods:{
		bindEventHandlers(){
			const self = this
			window.addEventListener('offline', function () {
				self.setStatus('offline')
				EventBus.$emit('isOnline', false)
			})
			window.addEventListener('online', function () {
				self.setStatus('online')
				EventBus.$emit('isOnline', true)
			})
		},
		setStatus(status){
			var $this = this
			if(status ==='online'){
				$this.status = {
					val : 'Online',
					bool : true
				}
			}else{
				$this.status = {
					val : 'Offline',
					bool : false
				}
			}
		}
	},
	data(){
		return{
			status:{
				val: '',
				bool: true
			}
		}
	}
}
</script>
